import {useElementSize} from '~/composables/dom/useElementSize'

declare global {
  interface Window {
    stage: createjs.Stage
  }
}

const baseStageCanvasWidth = 550
const baseStageCanvasControllerHeight = 40
const overlayRelativeMargin = 10

function getFrameDocument(mediaFrame: HTMLIFrameElement): Document | null {
  return mediaFrame.contentDocument
}

function getStageCanvas(mediaFrame: HTMLIFrameElement): HTMLCanvasElement | null {
  return getFrameDocument(mediaFrame)?.querySelector('canvas') ?? null
}

function getFrameStage(mediaFrame: HTMLIFrameElement) {
  return getFrameDocument(mediaFrame)?.defaultView?.stage
}

function getCompositeCanvasHeight(stageCanvas: HTMLCanvasElement, displayMode: boolean = false) {
  return (displayMode ? useElementSize(stageCanvas).width : stageCanvas.width) / computeCanvasSizeProps(stageCanvas).compositeCanvasWidthHeightRatio
}

function getScaleRatio(stageCanvas: HTMLCanvasElement, displayMode: boolean = false) {
  return (displayMode ? useElementSize(stageCanvas).width : stageCanvas.width) / baseStageCanvasWidth
}

function computeCanvasSizeProps(stageCanvas: HTMLCanvasElement) {
  const canvasWidth = stageCanvas.width// || $mediaFrame.get(0).contentWindow.lib.properties.width;
  const canvasHeight = stageCanvas.height// || $mediaFrame.get(0).contentWindow.lib.properties.height;

  const currentScaleRatio = canvasWidth / baseStageCanvasWidth
  const baseStageCanvasHeight = canvasHeight / currentScaleRatio
  const originalHeightWithoutController = baseStageCanvasHeight - baseStageCanvasControllerHeight

  const compositeCanvasWidthHeightRatio = baseStageCanvasWidth / originalHeightWithoutController

  return {
    canvasWidth,
    canvasHeight,
    currentScaleRatio,
    baseStageCanvasHeight,
    originalHeightWithoutController,
    compositeCanvasWidthHeightRatio,
  }
}

export const useMediaFrameElements = () => {
  return {
    baseStageCanvasWidth,
    baseStageCanvasControllerHeight,
    overlayRelativeMargin,
    getFrameDocument,
    getStageCanvas,
    getFrameStage,
    getCompositeCanvasHeight,
    computeCanvasSizeProps,
    getScaleRatio,
  }
}